import { createTheme, Theme } from '@mui/material';

const MuiComponentsConfig = (themeRedux: Theme): Theme => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const bg = themeRedux.palette.background as any;

  return createTheme({
    ...themeRedux,
    components: {
      MuiSelect: {
        defaultProps: {
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: bg.panel,
                backgroundImage:
                  'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
              },
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          popper: {
            zIndex: 11,
            '& div': {
              backgroundColor: bg.panel,
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: bg.panel,
            backgroundImage:
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: bg.panel,
            backgroundImage:
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {},
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            color: themeRedux.palette.text.primary,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            color: themeRedux.palette.text.primary,
            border: '1px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            height: '20px',
            fontSize: '0.7125rem',
          },
        },
      },
      MuiListSubheader: {
        styleOverrides: {
          root: {
            backgroundColor: bg.accordionHeader,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          outlined: {
            color:
              themeRedux.palette.mode === 'light'
                ? themeRedux.palette.primary.dark
                : themeRedux.palette.info.dark,
            borderColor:
              themeRedux.palette.mode === 'light'
                ? themeRedux.palette.primary.dark
                : themeRedux.palette.info.dark,
            '&:hover': {
              borderColor:
                themeRedux.palette.mode === 'light'
                  ? themeRedux.palette.primary.main
                  : themeRedux.palette.info.main,
              color:
                themeRedux.palette.mode === 'light'
                  ? themeRedux.palette.primary.main
                  : themeRedux.palette.info.main,
            },
          },
        },
      },
    },
  });
};

export default MuiComponentsConfig;
